import React, { useEffect } from 'react'
import { M_SimpleTable, M_DrawerTableTextField, M_Button } from 'src/components/M_Components'

export default function ADR({ optionsADR, ADRMap, setADRMap, ctx, t, operation, addADR }) {

    useEffect(() => {
        if (operation === 'create' && ADRMap.length < 1) {
            addADR()
        }
    }, [])

    const headerTable = optionsADR.map((value, index) => {
        return {
            id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Name === 'Description') {
                    return (
                        <div >
                            <M_DrawerTableTextField
                                tableLabel={value.NormalizedName}
                                label={value.NormalizedName}
                                required={value.IsRequired}
                                entity={value.ForeignTableName}
                                value={line[value.ForeignTableToPassId] &&
                                {
                                    [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                    [value.ForeignKeyName]: line[value.Name]
                                } || null}
                                filterField={value.ForeignKeyName}
                                labelFields={[value.ForeignKeyName]}
                                onSubmitValue={obj => {
                                    if (obj) {
                                        createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id)
                                        createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id)
                                        createStructureADR(obj.Class || '', 'Class', line.Id)
                                        createStructureADR(obj.SubClass || '', 'SubClass', line.Id)
                                        createStructureADR(obj.Type || '', 'Type', line.Id)
                                        createStructureADR(obj.Efficiency || '', 'Efficiency', line.Id)
                                        createStructureADR(obj.Tanker || '', 'Tanker', line.Id)
                                    } else {
                                        createStructureADR('', value.Name, line.Id)
                                        createStructureADR('', value.ForeignTableToPassId, line.Id)
                                        createStructureADR('', 'Class', line.Id)
                                        createStructureADR('', 'SubClass', line.Id)
                                        createStructureADR('', 'Type', line.Id)
                                        createStructureADR('', 'Efficiency', line.Id)
                                        createStructureADR('', 'Tanker', line.Id)

                                    }
                                }}
                                disabled={value.disable}
                                valueField={value.ForeignTableToPassId}
                            />
                        </div>)
                }
                return (line[value.Name]) || '---'
            }
        }
    })

    const createStructureADR = (value, field, id) => {
        setADRMap(prev =>
            prev.map(item =>
                item.Id === id
                    ? { ...item, [field]: value }
                    : item
            )
        )
    }

    const deleteADR = (id) => {
        if (ADRMap.length > 1) {
            setADRMap(prev => prev.filter(obj => obj.Id !== id))
            ctx.toastMessages('success', '', t("DeleteLine"))
        } else {
            ctx.toastMessages('error', '', t("ErrorDeletingLine"))
        }
    }


    return (
        <div className='divAlignTableADR'>
            <M_SimpleTable
                columns={[
                    ...headerTable,
                    {
                        body: (line) => {
                            return (
                                <div style={{ width: '50px' }}>
                                    <img src="/icons/svgsDaNet/trash-2.svg"
                                        style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                        alt="Delete" className='iconDeleteAddress' onClick={() => deleteADR(line.Id)}
                                    />
                                </div>
                            )
                        }
                    }
                ]}
                rows={ADRMap}
                className='TableADR'
                width={'100%'}
            />
        </div>
    )
}